import audio from '../../../../assets/audio/kids-tracks/Text7.mp3';

export const step8road = {
    id: 8,
    title: 'Cestička',
    taskText: `
        <p>
            Dobrá práce! Všechny ryby i další zvířátka, co se tu rády koupají, nám děkují. 
            A teď můžeme pokračovat v naší cestě. Pejsek už se rozběhl a míří támhle nahoru k té lavičce. 
            On na ní někdo vážně sedí, že by to byla hraběnka? 
        </p>
    `,
    continueButtonText: 'Jsme u lavičky',
    cipher: {
        text: 'Vydejte se cestou vpravo a přisedněte si na první lavičku za hraběnkou',
        label: 'Úkol',
    },
    audio: audio,
    points: false,
};
